// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1aKqB","addWidgetButton":"Header_addWidgetButton__2ogu4","dashboardTabs":"Header_dashboardTabs__3RFDC","active":"Header_active__2LWFJ"};